import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
} from '@/components/common/skeleton';

const CARD_COUNT = 6;

export const EventsScreenSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    {Array.from({ length: CARD_COUNT }).map((_, i) => (
      <SkeletonCard key={i} style={styles.cardSpacing}>
        <View style={styles.cardHeader}>
          <SkeletonBone width="70%" height={18} />
          <SkeletonBone width={60} height={24} borderRadius={12} />
        </View>
        <SkeletonBone width="50%" height={14} />
        <SkeletonBone width="70%" height={14} />
        <SkeletonBone width="40%" height={14} />
      </SkeletonCard>
    ))}
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingTop: 12,
  },
  cardSpacing: {
    marginBottom: 12,
  },
  cardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
});
